// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"title-module--wrapper--l-zqg","label":"title-module--label--2LNtw","background":"title-module--background--wzUly","inverted":"title-module--inverted--39Pw1"};